import { Component, EventEmitter, Output, Input, ViewChild, OnInit, AfterContentInit, ElementRef } from '@angular/core';
import { BlockEmoji } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-expandable-textarea',
  templateUrl: './ui-expandable-textarea.html',
  styleUrls: ['./ui-expandable-textarea.component.scss']
})
export class UiExpandableTextareaComponent implements OnInit, AfterContentInit {
  @Input() placeholder: string = '';
  @Input() minHeight: number = 70;
  @Input() rows: number = 1;
  @Input() maxLength: number = null;
  @Input() disabled: boolean = false;
  @Input() allowEmoji: boolean;
  @Input() styles = {};

  @Input()
  public get model() {
    return this.text;
  }

  public set model(text: string) {
    this.delayedResize(this.text && text && this.text.length > text.length);
    this.text = text;
    this.modelChange.emit(this.text);
  }

  @Output() modelChange = new EventEmitter<string>();
  @Output() onResize = new EventEmitter<number>();

  @ViewChild('textArea', { static: false }) textArea: ElementRef<HTMLTextAreaElement>;

  public text: string;

  ngOnInit() {
    const defaultStyles = { 'min-height.px': this.minHeight };
    this.styles = { ...defaultStyles, ...this.styles };
  }

  public blockEmoji(text: string): void {
    const filteredText = !this.allowEmoji && text ? BlockEmoji(text) : text;
    this.textArea.nativeElement.value = filteredText;
    this.model = filteredText;
  }

  public ngAfterContentInit(): void {
    this.resize();
  }

  public resize(withReset: boolean = false) {
    if (!this.textArea) {
      return;
    }

    if (withReset) {
      this.textArea.nativeElement.style.height = 'auto';
    }

    this.textArea.nativeElement.style.height = this.textArea.nativeElement.scrollHeight + 'px';
    this.onResize.emit(this.textArea.nativeElement.scrollHeight);
  }

  public delayedResize(withReset: boolean = false) {
    setTimeout(() => this.resize(withReset), 0);
  }
}
